<section class="container py-4">
  <!-- List View -->
  <div *ngIf="!isViewingDocument" class="container p-4 app-container">
    <!-- Header Section -->
    <div class="d-flex align-items-center mb-3">
      <button
        class="btn-back"
        (click)="navigateToBackPage()"
        aria-label="Go back"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        <span class="back-text">Back</span>
      </button>

      <h2 class="page-title mb-0 ms-3">E-Content Documents</h2>

      <button
        mat-raised-button
        color="primary"
        class="ms-auto"
        (click)="openAddDialog(dialogTemplate)"
      >
        <mat-icon>add</mat-icon>
        Add Document
      </button>
    </div>

    <!-- Document Table -->
    <div class="table-responsive">
      <table
        mat-table
        [dataSource]="documents"
        class="mat-elevation-z1 full-width-table"
      >
        <!-- Columns -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Document Name</th>
          <td mat-cell *matCellDef="let doc">{{ doc.title }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let doc">
            <div class="d-flex align-items-center">
              <mat-icon class="me-1">{{ getFileTypeIcon(doc.type) }}</mat-icon>
              {{ doc.type }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef>Size</th>
          <td mat-cell *matCellDef="let doc">{{ doc.size }}</td>
        </ng-container>

        <ng-container matColumnDef="uploadedDate">
          <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
          <td mat-cell *matCellDef="let doc">
            {{ doc.updated_at | date : "dd-MMM-yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="uploadedBy">
          <th mat-header-cell *matHeaderCellDef>Uploaded By</th>
          <td mat-cell *matCellDef="let doc">{{ doc.uploadedBy }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let doc">
            <span
              class="status-badge"
              [ngClass]="{
                approved: doc.status === 'Approved',
                pending: doc.status === 'Pending',
                rejected: doc.status === 'Rejected'
              }"
            >
              {{ doc.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let doc">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="handleAction('view', doc.id)">
                <mat-icon>visibility</mat-icon> View
              </button>
              <button mat-menu-item (click)="handleAction('edit', doc.id)">
                <mat-icon>edit</mat-icon> Edit
              </button>
              <button mat-menu-item (click)="handleAction('delete', doc.id)">
                <mat-icon>delete</mat-icon> Delete
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <!-- Document Viewer -->
  <div *ngIf="isViewingDocument" class="container p-4 app-container">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <button class="btn-back" (click)="backToList()" aria-label="Go back">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        <span class="back-text">Back to List</span>
      </button>

      <h2 class="page-title mb-0 ms-3">File Viewer</h2>
      <button mat-raised-button color="primary" (click)="downloadDocument()">
        <mat-icon>download</mat-icon>
        Download Document
      </button>
    </div>

    <div class="document-viewer-content">
      <div *ngIf="currentDocumentType === 'image'" class="image-container">
        <img [src]="currentDocumentUrl" alt="Document" class="document-image" />
      </div>

      <div *ngIf="currentDocumentType === 'pdf'" class="pdf-container">
        <iframe
          [src]="currentDocumentUrl"
          width="100%"
          height="600px"
          style="border: none"
          title="PDF Document"
        >
        </iframe>
      </div>

      <div
        *ngIf="
          currentDocumentType === 'word' ||
          currentDocumentType === 'excel' ||
          currentDocumentType === 'powerpoint'
        "
        class="office-container"
      >
        <iframe
          [src]="currentDocumentUrl"
          width="100%"
          height="600px"
          style="border: none"
          title="Office Document"
        >
        </iframe>
      </div>

      <div *ngIf="currentDocumentType === 'unknown'" class="unknown-container">
        <div class="alert alert-info">
          <mat-icon class="me-2">info</mat-icon>
          This document type cannot be previewed. Please download the file to
          view it.
        </div>
        <button mat-raised-button color="primary" (click)="downloadDocument()">
          <mat-icon>download</mat-icon>
          Download Document
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Dialog Template -->
<ng-template #dialogTemplate>
  <h2 mat-dialog-title>Add New Document</h2>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-3">
      <div class="">
        <div *ngFor="let question of questions" class="py-4">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>

      <!-- File Upload -->
      <div class="mb-3">
        <label class="d-block mb-2 fw-semibold">Upload Document or Image</label>
        <button
          mat-raised-button
          color="accent"
          type="button"
          (click)="fileInput.click(); $event.stopPropagation()"
        >
          Select File
        </button>
        <input
          #fileInput
          type="file"
          hidden
          (change)="onFileSelected($event)"
          (click)="$event.stopPropagation()"
          accept="image/*,application/pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
        />

        <div *ngIf="filePreview && isImage" class="mt-2">
          <img
            [src]="filePreview"
            alt="Preview"
            class="rounded"
            style="max-width: 180px; max-height: 120px"
          />
        </div>

        <div *ngIf="fileName && !isImage" class="mt-2">
          <mat-icon>insert_drive_file</mat-icon>
          <span>{{ fileName }}</span>
        </div>
      </div>

      <!-- Dialog Actions -->
      <mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="primary" type="submit">Submit</button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</ng-template>
